import { useLazyFetch } from 'src/hooks/useLazyFetch'

const useGetIbgeCountries = () => {
  const [getIbgeCountries, getIbgeCountriesResult] = useLazyFetch()

  return [
    () => {
      getIbgeCountries({
        url: 'https://servicodados.ibge.gov.br/api/v1/localidades/paises?orderBy=nome',
        method: 'GET',
      })
    },
    getIbgeCountriesResult,
  ] as const
}

const useGetIbgeStates = () => {
  const [getIbgeStates, getIbgeStatesResult] = useLazyFetch()

  return [
    () => {
      getIbgeStates({
        url: 'https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome',
        method: 'GET',
      })
    },
    getIbgeStatesResult,
  ] as const
}

const useGetIbgeCities = () => {
  const [getIbgeCities, getIbgeCitiesResult] = useLazyFetch()

  return [
    (stateId: number) => {
      getIbgeCities({
        url: `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${stateId}/municipios?orderBy=nome`,
        method: 'GET',
      })
    },
    getIbgeCitiesResult,
  ] as const
}

export { useGetIbgeCountries, useGetIbgeStates, useGetIbgeCities }
